module.exports = __webpack_public_path__ + "img/tddg-1.7979a08d.webp";